import React, { Component } from "react";
import "./list.scss";
import { connect } from "react-redux";
import dongcheng from "@/assets/list/dongcheng@3x.png";
import xindongchengbao from "@/assets/list/xindongchengbao@3x.png";
import weibo from "@/assets/list/weibo@3x.png";
import home_h5_weixin from "@/assets/list/home_h5_weixin@3x.png";
import douyin from "@/assets/list/douyin@3x.png";
import home_h5_kuaishou from "@/assets/list/home_h5_kuaishou@3x.png";
import home_h5_yangxhipin from "@/assets/list/home_h5_yangxhipin@3x.png";
import toutiao from "@/assets/list/toutiao@3x.png";
// import yidian from "@/assets/list/yidian@3x.png";
// import kuaibao from "@/assets/list/kuaibao@3x.png";
import home_h5_weishi from "@/assets/list/home_h5_weishi@3x.png";

@connect((state) => ({ admin: state.admin }), {})
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [
        {
          url: "http://www.dcrmxdcb.cn/",
          title: "新东城报",
          label: "",
          img: xindongchengbao,
        },
        {
          url: "https://cmsuiv3.aheading.com/MNewsPaperGroup/SpecialIndex?newsPaperGroupId=8011&cId=41030&TypeValue=4&IsShowIcon=true",
          title: "都市阳光",
          label: "BTV新闻",
        },
        {
          url: "https://cmsuiv3.aheading.com/MNewsPaperGroup/Index?newsPaperGroupId=8010",
          title: "美丽东城",
          label: "网络电视",
        },
        { url: "https://m.weibo.cn/u/2590506110", label: "微博", icon: weibo },
        {
          url: "http://cdn.bjnews.com.cn/dc_h5/main/attentionStep/index.html",
          label: "微信",
          icon: home_h5_weixin,
        },
        { url: "https://v.douyin.com/JJKYb7r/", label: "抖音", icon: douyin },
        {
          url: "https://kpfshanghai.m.chenzhongtech.com/fw/user/bjdchksh?fid=181378027&cc=share_wxms&shareMethod=CARD&docId=0&kpn=KUAISHOU&subBiz=PROFILE&shareId=185480589058&docABKey=share_textid_profile&shareToken=X4dB63SaXCNLKRW_A&shareResourceType=PROFILE_OTHER&groupABKey=share_group_profile&groupName=&expTag=null&appType=1&shareObjectId=1363604464&shareUrlOpened=0&from=singlemessage&isappinstalled=0",
          label: "快手",
          icon: home_h5_kuaishou,
        },
        {
          url: "https://m.yangshipin.cn/user?cpid=20690202328446062&ptag=4_1.2.0.20355_wxf&from=singlemessage&isappinstalled=0",
          label: "央视频",
          icon: home_h5_yangxhipin,
        },
        {
          url: "https://www.toutiao.com/c/user/token/MS4wLjABAAAAaKvFsV_0T3TghDVNuxGaI8H-DsnlgcdmOr6NwQp30Qc/",
          label: "头条",
          icon: toutiao,
        },
        // {
        //   url: "https://www.yidianzixun.com/channel/m554275",
        //   label: "一点资讯",
        //   icon: yidian,
        // },
        // {
        //   url: "http://kuaibao.qq.com/s/MEDIANEWSLIST?refer=kb_media&chlid=5226871",
        //   label: "天天快报",
        //   icon: kuaibao,
        // },
        {
          url: "https://h5.weishi.qq.com/weishi/personal/1524381304246504/wspersonal?_wv=1&id=1524381304246504&from=singlemessage&isappinstalled=0",
          label: "微视",
          icon: home_h5_weishi,
        },
      ],
    };
  }

  componentWillMount() {}

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <div className="list-page">
        {this.state.list.map((item, index) => {
          return (
            <div
              key={index}
              className="item-box"
              onClick={() => {
                window.open(item.url);
              }}
            >
              {item.icon ? <img src={item.icon} alt="" className="icon" /> : ""}
              <img src={item.img || dongcheng} alt="" className="image" />
              <div className="title">{item.title || "北京东城"}</div>
              <div className="label">{item.label}</div>
            </div>
          );
        })}
      </div>
    );
  }
}
export default List;




// WEBPACK FOOTER //
// ./src/pages/List/list.js